import { Component } from '@angular/core';

@Component({
  selector: 'svg-sequence-diagram',
  standalone: true,
  template: `
    <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path
        d="m20 24h-8.1375a4.13 4.13 0 0 0 -.4284-1.02l10.5459-10.5457a3.9943 3.9943 0 1 0 -1.8386-4.4343h-6.1414v2h6.1414a3.96 3.96 0 0 0 .4243 1.02l-10.5457 10.5456a3.9943 3.9943 0 1 0 1.8387 4.4344h8.1413v3h8v-8h-8zm4-17a2 2 0 1 1 -2 2 2.0023 2.0023 0 0 1 2-2zm-16 20a2 2 0 1 1 2-2 2.0023 2.0023 0 0 1 -2 2zm14-4h4v4h-4z" />
      <path d="m9.6929 12.7505a5 5 0 0 1 -.0005-7.5l1.3242 1.4995a3 3 0 0 0 -.0005 4.501z" />
      <path d="m7.0474 15.751a9 9 0 0 1 0-13.501l1.3232 1.5a7 7 0 0 0 0 10.501z" />
      <path d="m0 0h32v32h-32z" fill="none" />
    </svg>
  `,
  styleUrl: './svg.style.scss',
})
export class SvgSequenceDiagramComponent {}
